<template>
<div>

  <tti-header></tti-header>

  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="bg-white pt-12 pb-20 px-4 sm:px-6  lg:pb-28 lg:px-8">
    <div class="relative max-w-lg mx-auto lg:max-w-7xl">
      <div>
        <h2 class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
          Articles
        </h2>
        <p class="mt-3 text-xl text-gray-500 sm:mt-4">
          Keep up to date with news and useful articles from both The Tutor Index and our featured members.
        </p>
      </div>
      <div class="mt-20 grid gap-16 lg:grid-cols-3 lg:gap-x-5 lg:gap-y-12">

        <tti-article-summary v-for="article in articles" :key="article.url" :article="article">
        </tti-article-summary>

      </div>
    </div>
  </div>

  <tti-footer></tti-footer>

</div>
</template>
<script>
import ArticleService from '@/services/ArticleServices'
const articleService = new ArticleService()

export default {
  components: {
    'tti-header': () => import('./HeaderNew'),
    'tti-footer': () => import('./Footer'),
    'tti-article-summary': () => import('./Article-Summary')
  },
  data() {
    return {
      articles: []
    }
  },
  async mounted() {
    this.articles = await articleService.getRecentArticles(1, 100);
  }
}
</script>